import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
import { editorStore } from "../../stores/EditorStore";
import { imageStore } from "../../stores/ImageStore";
import { undoableCreateImage } from "../../stores/undo/operation/ImageCreateOp";
import { undoableDeleteImage } from "../../stores/undo/operation/ImageDeleteOp";
import { FileUploadButton } from "../shared/FileUploadButton";
const ImageSelector = styled.div.withConfig({
  displayName: "ImageSelectionWithUpload__ImageSelector",
  componentId: "sc-1pfq322-0"
})(["background:white;border:1px solid darkgray;padding:3px;margin:3px;width:280px;max-height:500px;display:flex;flex-wrap:wrap;justify-items:center;max-height:280px;overflow-y:scroll;"]);
const Image = styled.img.withConfig({
  displayName: "ImageSelectionWithUpload__Image",
  componentId: "sc-1pfq322-1"
})(["max-width:100%;max-height:100%;"]);
const ImageField = styled.div.withConfig({
  displayName: "ImageSelectionWithUpload__ImageField",
  componentId: "sc-1pfq322-2"
})(["width:85px;height:85px;margin:auto;padding:10px;cursor:pointer;border-radius:", ";&:hover{background-color:", ";}background-color:", ";"], UiConstants.BORDER_RADIUS, UiConstants.COLOR_HOVER, props => props.selected ? UiConstants.COLOR_SELECTION_HIGHLIGHT : "white");
export const ImageSelectionWithUpload = observer(({
  selectedImageId,
  selectedImageIdSetter,
  imageUsecase
}) => {
  const {
    t
  } = useTranslation();
  const availableImages = imageStore.getAllImageMetadataOfUsecase(imageUsecase);
  const [selectedImageFile, setSelectedImageFile] = useState(null);

  async function uploadImage() {
    if (!selectedImageFile) return;
    undoableCreateImage(selectedImageFile, imageUsecase);
    setSelectedImageFile(null);
  }

  function deleteImage() {
    if (!selectedImageId) return;
    undoableDeleteImage(selectedImageId);
    setSelectedImageFile(null);
  }

  function userHasEditRights() {
    var _availableImages$find;

    if (editorStore.isMainGameEditor) return true;
    return ((_availableImages$find = availableImages.find(i => i.id == selectedImageId)) === null || _availableImages$find === void 0 ? void 0 : _availableImages$find.moduleOwner) === editorStore.sessionModuleId;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImageSelector, null, /*#__PURE__*/React.createElement(ImageField, {
    onClick: () => selectedImageIdSetter(0),
    selected: !selectedImageId
  }), availableImages.map(image => /*#__PURE__*/React.createElement(ImageField, {
    key: image.id,
    onClick: () => selectedImageIdSetter(image.id),
    selected: image.id === selectedImageId
  }, /*#__PURE__*/React.createElement(Image, {
    src: imageStore.getImageUrl(image.id)
  })))), /*#__PURE__*/React.createElement(FileUploadButton, {
    onFileSelected: setSelectedImageFile,
    acceptMimeType: "image/png",
    labelText: t("editor.item_pick_file")
  }), selectedImageFile != null && /*#__PURE__*/React.createElement("button", {
    onClick: uploadImage
  }, t("editor.item_upload_image")), selectedImageId !== 0 && userHasEditRights() && /*#__PURE__*/React.createElement("button", {
    onClick: deleteImage
  }, t("editor.delete_image")));
});